import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountSettingResponse } from '@/repositories/generated';

const response: AccountSettingResponse = {
  passwordMinDigits: 12,
  passwordCharacterType: 'ALPHANUMERIC_UPPERCASE_LOWERCASE_REQUIRED',
};

export const accountSetting = http.get(
  createMockEndpoint('/system_setting/account'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
